<template>
  <CustomTooltip>
    <button
      v-bind="$attrs"
      ref="btnRef"
      type="button"
    >
      <img :src="PauseIcon" alt="">
    </button>

    <template #content>
      <span>Pause</span>
      <kbd class="bg-white text-black-50 ml-1">space</kbd>
    </template>
  </CustomTooltip>
</template>

<script>
import { onKeyStroke } from '@vueuse/core'
import { ref } from 'vue'
import CustomTooltip from '@/components/custom-tooltip.vue'
import { PauseIcon } from '../../../common/icons'

export default {
  name: 'WebcamRecorderPauseRecordingButton',
  components: { CustomTooltip },
  inheritAttrs: false,
  setup() {
    const btnRef = ref(null)

    onKeyStroke(' ', () => {
      btnRef.value?.click()
    })

    return {
      PauseIcon,
      btnRef,
    }
  },
}
</script>
